import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import TermoUso from '../Componente/Modais/TermoUso';
import BoasVindas from '../Componente/Modais/BoasVindas';


import './Footer.scss';

class Footer extends Component {
	retornarEconet() {
		var url = 'https://www.econeteditora.com.br/index.asp';
		var win = window.open(url, '_blank');
		win.focus();
	}

	render = () => (
		<Row id="footer">
		<TermoUso ref={modal => (this.TermoUso = modal)} />
		{/* <BoasVindas ref={modal => (this.BoasVindas = modal)} /> */}
			<Col>
				<Row className="h-100">
					<Col sm={11} className="bottom-outside col" />
					<Col sm={1} className="skew-left bottom-inside col" />
				</Row>
			</Col>
			<Col sm={9} className="bottom-center">
				<span>Copyright 2025 ® - Todos os Direitos Reservados e Econet Editora Empresarial - </span>
				<span className="termos-uso" onClick={() => this.TermoUso.openModal()}> Termos de uso.</span>
				{/* <span className="termos-uso" onClick={() => this.BoasVindas.openModal()}> BoasVindas.</span> */}
				<img alt="" src="/img/logo-econet.png" onClick={() => this.retornarEconet()} />
			</Col>
			<Col>
				<Row className="h-100">
					<Col sm={1} className="skew-right bottom-inside col" />
					<Col sm={11} className="bottom-outside col" />
				</Row>
			</Col>
		</Row>
	);
}

export default Footer;
